export class RenderRectangleOptions {
    public readonly color?: string = '#ffffff';
    public readonly alpha?: number = 1.0;
    public readonly filled?: boolean = true;
}